import { formatDate3 } from "../../../../../../utils";
import { CurrencyFormatDisplay } from "components/UI/NumberFormatDisplay/CurrencyFormatDisplay";

interface IHouseholdIncomeDetails {
  age: string;
  familyMemberName: string;
  id: string;
  otherIncome?: string;
  pensions?: string;
  publicAssistance?: string;
  relation: string;
  wages?: string;
}

interface IHouseholdIncomeProps {
  householdIncome: Array<IHouseholdIncomeDetails>;
}
export default function HouseholdIncomeDetails({
  householdIncome,
}: IHouseholdIncomeProps) {
  const totalWages = householdIncome?.reduce(
    (acc: number, curr: IHouseholdIncomeDetails) => {
      const wage = curr?.wages ? Number(curr?.wages) : 0;
      return (acc += wage);
    },
    0
  );
  const totalPension = householdIncome?.reduce(
    (acc: number, curr: IHouseholdIncomeDetails) => {
      const pensions = curr?.pensions ? Number(curr?.pensions) : 0;
      return (acc += pensions);
    },
    0
  );
  const totalPublicAssistance = householdIncome?.reduce(
    (acc: number, curr: IHouseholdIncomeDetails) => {
      const publicAssistance = curr?.publicAssistance
        ? Number(curr?.publicAssistance)
        : 0;
      return (acc += publicAssistance);
    },
    0
  );
  const totalOtherIncome = householdIncome?.reduce(
    (acc: number, curr: IHouseholdIncomeDetails) => {
      const otherIncome = curr?.otherIncome ? Number(curr?.otherIncome) : 0;
      return (acc += otherIncome);
    },
    0
  );

  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal">
                House Hold Income Detail
              </h2>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-3">
            <div>
              <div className="space-y-2 w-full h-full ring-1 ring-neutralColor-lighter overflow-x-scroll">
                <table className="divide-y divide-gray-200 w-full">
                  <thead className="bg-gray-100">
                    <tr className="flex justify-between px-5 py-4">
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-60">
                        Family Member Name
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40">
                        Age
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40">
                        Relation
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-32">
                        Yearly Income ($)
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40">
                        Pension ($)
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40">
                        Public Assistance ($)
                      </th>
                      <th className="flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40">
                        Other Income ($)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {householdIncome?.map((income: IHouseholdIncomeDetails) => (
                      <tr
                        key={income.id}
                        className="flex items-center w-full justify-between px-5 py-2">
                        <td className="w-60 flex items-start capitalize">
                          {income?.familyMemberName}
                        </td>
                        <td className="w-40 flex items-start capitalize">
                          {income?.age}
                        </td>
                        <td className="w-40 flex items-start capitalize">
                          {income?.relation}
                        </td>

                        <td className="w-32 flex items-start capitalize">
                          <CurrencyFormatDisplay value={income.wages || 0} />
                        </td>

                        <td className="w-40 flex items-start capitalize">
                          <CurrencyFormatDisplay
                            value={income?.pensions || 0}
                          />
                        </td>
                        <td className="w-40 flex items-start capitalize">
                          <CurrencyFormatDisplay
                            value={income.publicAssistance || 0}
                          />
                        </td>

                        <td className="w-40 flex items-start capitalize">
                          <CurrencyFormatDisplay
                            value={income?.otherIncome || 0}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr className="flex items-center w-full justify-between px-5 py-2">
                      <td className="w-60 font-bold">Total</td>
                      <td className="w-40"></td>
                      <td className="w-40"></td>
                      <td className="w-32 font-bold">
                        <CurrencyFormatDisplay value={totalWages ?? 0} />
                      </td>

                      <td className="w-40 font-bold">
                        <CurrencyFormatDisplay value={totalPension ?? 0} />
                      </td>

                      <td className="w-40 font-bold">
                        <CurrencyFormatDisplay
                          value={totalPublicAssistance ?? 0}
                        />
                      </td>
                      <td className="w-40 font-bold">
                        <CurrencyFormatDisplay value={totalOtherIncome ?? 0} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
